// Deliberately loose, because neither page that reads it is the thing that decides: /keygen's address only has to
// survive OpenPGP's own parser, and /qr-code's only has to be something the mail client a camera hands it to will
// open. What is worth catching either way is an address with no `@` in it, or a host with no dot.
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
